import Cookies from 'js-cookie'
import React, { ChangeEvent, useState } from 'react'
import { Overlay } from 'suf_storybook'

type InputProps = {
  isOpen: boolean
  marketoFormId: string
  slug: string
  handleCloseClick: () => void
}

const translations = {
  en: {
    title: 'Notice to Australian Users',
    mainContent: `A Sustainable Fitch ESG Analytical Product (“ESG Product”) provides an assessment of the Environmental,
    Social and/or Governance (“E”, “S” and “G”) qualities of an issuer and/or its securities.
    ESG Products include without limitation ESG ratings, ESG scores, ESG second-party opinions and other ESG assessments and data-related products,
    among other ESG Products. An ESG Product is not a credit rating. ESG Products are provided by Sustainable Fitch.`,
    mainContent2: `ESG Products in Australia are available only to wholesale clients (as defined in sections 761G and 761GA of the Corporations Act 2001 (Cth) (the “Act”))
    in Australia. Information related to ESG Products published by Sustainable Fitch is not intended to be used by persons who are retail clients within the meaning of sections
    761G and 761GA of the Act (“Retail Clients”) in Australia.`,
    mainContent3: `No one shall distribute, disclose or make references to any information related to ESG Products in a manner which is intended to (or could reasonably be regarded as being intended to) influence a Retail Client in making a decision in relation to a particular financial product (as defined in the Act) or class of financial products,
    unless required to do so by law to meet continuous disclosure obligations. No one shall make reference to any ESG Product information in any publication, promotional material, disclosure document,
    correspondence, website, or any other venue that may be accessed by clients and investors who are Retail Clients in Australia (except in the circumstances as permitted by law).`,
    mainContent4: `Sustainable Fitch does not hold an Australian financial services license to provide general
    financial product advice and the ESG Products are provided subject to the conditions of the SPO class no-action
     position to second party opinion providers issued by the Australian Securities & Investments Commission on 14 June 2024.`,
    mainContent5: `In order to access information on this website, you must verify that you are not a person who would be considered to be a retail client under Australian laws.
      If you are a retail investor, you will not be able to access ESG Products on our website.`,
    selectPrompt: 'Please select the relevant radio button below:',
    notRetailClient:
      'I am <u><strong>not</strong></u> a retail client in Australia',
    retailClient: 'I am a retail client in Australia',
    whoIsRetailClient: 'Who is a retail client?',
    retailClientContent: `Please refer to the definitions under sections 761G and 761GA of the`,
    corporationsAct: 'Corporations Act 2001 (Cth).',
    submit: 'Submit'
  }
}

const AustraliaOverlay: React.FC<InputProps> = ({
  isOpen,
  handleCloseClick,
  language
}) => {
  const [typeOfUser, setTypeOfUser] = useState('')

  const content = translations[language]
  const onCheckedHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setTypeOfUser(e.currentTarget.value)
  }

  const onSubmitHandler = () => {
    if (typeOfUser !== '') {
      const cookieExpiration = new Date()
      cookieExpiration.setFullYear(cookieExpiration.getFullYear() + 1)
      Cookies.set('AUS_USERTYPE', typeOfUser, {
        expires: cookieExpiration
      })
      if (typeOfUser === 'retail') {
        window.location.assign('https://asic.gov.au/')
      }
      handleCloseClick()
    }
  }

  return (
    <Overlay
      isOpen={isOpen}
      className="overlay-content-wrapper active australian-notice"
    >
      <div className="overlay__header">
        <h3 className="heading--3">{content.title}</h3>
      </div>
      <div className="overlay__content">
        <div className="content">
          <p>{content.mainContent}</p>
          <p>{content.mainContent2}</p>
          <p>{content.mainContent3}</p>
          <p>{content.mainContent4}</p>
          <p>{content.mainContent5}</p>
          <h5 className="heading--6">{content.selectPrompt}</h5>

          <form
            className="mktoForm clearfix"
            style={{ marginBottom: '1.2rem' }}
          >
            <div className="mktoCheckboxList">
              <input
                type="radio"
                name="typeOfUser"
                id="subscriber"
                value="subscriber"
                onChange={onCheckedHandler}
              />
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label
                htmlFor="subscriber"
                dangerouslySetInnerHTML={{ __html: content.notRetailClient }}
              />
            </div>
            <div className="mktoCheckboxList">
              <input
                type="radio"
                name="typeOfUser"
                id="retail"
                value="retail"
                onChange={onCheckedHandler}
              />
              <label htmlFor="retail" data-testid="retail-option">
                {content.retailClient}
              </label>
            </div>
          </form>

          <h5 className="heading--6">{content.whoIsRetailClient}</h5>
          <p style={{ padding: '0' }}>
            {content.retailClientContent}{' '}
            <a
              href="https://www5.austlii.edu.au/au/legis/cth/consol_act/ca2001172/"
              style={{ display: 'inline' }}
            >
              {content.corporationsAct}
            </a>
          </p>
        </div>
        <div className="mktoButtonRow">
          <button
            type="button"
            className="button button--1"
            onClick={onSubmitHandler}
            data-testid="submit"
          >
            {content.submit}
          </button>
        </div>
      </div>
    </Overlay>
  )
}

export default AustraliaOverlay
